import React from 'react';
import PropTypes from 'prop-types';
import { VaDate } from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import { useVaDateCommon } from './useVaDateCommon';

/**
 * @param {WebComponentFieldProps} props
 */
export default function VaDateField(props) {
  const { mappedProps, formattedValue, onDateChange, onDateBlur } =
    useVaDateCommon(props);

  return (
    <VaDate
      {...mappedProps}
      monthYearOnly={props.uiOptions?.monthYearOnly ?? false}
      monthOptional={props.uiOptions?.monthOptional ?? false}
      onDateChange={onDateChange}
      onDateBlur={onDateBlur}
      value={formattedValue}
    />
  );
}

VaDateField.propTypes = {
  uiOptions: PropTypes.shape({
    monthOptional: PropTypes.bool,
    monthYearOnly: PropTypes.bool,
  }),
};

VaDateField.identifier = 'VaDateField';
